export default __webpack_public_path__ + "static/media/battery.5435ec5f.png";